import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

function SEO({ description, lang, meta, title, pathname }) {
    const { site } = useStaticQuery(
        graphql`
            query{
                site{
                    siteMetadata{
                        title
                        description
                        author
                        siteLanguage
                        siteUrl
                    }
                }
            }
        `
    )

    const metaDescription = description || site.siteMetadata.description
    const canonical = pathname ? `${site.siteMetadata.siteUrl}${pathname}` : null
    // const image = 
    //         metaImage && metaImage.src
    //         ? `${site.siteMetadata.siteURL}${metaImage.src}`
    //         :null

    return (
        <Helmet 
            htmlAttributes={{
                lang,
            }}
            title={title}
            titleTemplate={`${site.siteMetadata.title} | ${title}`}
            link={
                canonical
                ? [
                    {
                        rel: "canonical",
                        href: "canonical"
                    },
                ]
                :[]
            }
            meta={[
                {
                    name: `description`,
                    content: metaDescription,
                },
                {
                    property: `og:title`,
                    content: title,
                },
                {
                    property: `og:description`,
                    content: metaDescription,
                },
                {
                    property: `og:type`,
                    content: `website`,
                },
                {
                    property: `twitter:creator`,
                    content: site.siteMetadata.author,
                },
                {
                    property: `twitter:title`,
                    content: title,
                },
                {
                    property: `twitter:description`,
                    content: metaDescription,
                }
            ]
            .concat(meta)
            }
        />
    )
}

SEO.defaultProps = {
    lang: `en`,
    meta: [],
    description: ``,
}

SEO.propTypes = {
    description: PropTypes.string,
    lang: PropTypes.string,
    meta: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string.isRequired,
    pathname: PropTypes.string
}

export default SEO